import { render, staticRenderFns } from "./RegisterItem.vue?vue&type=template&id=bff8470e&scoped=true&"
import script from "./RegisterItem.vue?vue&type=script&lang=js&"
export * from "./RegisterItem.vue?vue&type=script&lang=js&"
import style0 from "./RegisterItem.vue?vue&type=style&index=0&id=bff8470e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bff8470e",
  null
  
)

export default component.exports